import { render, staticRenderFns } from "./user_mangement.vue?vue&type=template&id=41aa52c5&scoped=true&"
import script from "./user_mangement.vue?vue&type=script&lang=js&"
export * from "./user_mangement.vue?vue&type=script&lang=js&"
import style0 from "./user_mangement.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./user_mangement.vue?vue&type=style&index=1&id=41aa52c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa52c5",
  null
  
)

export default component.exports